/**
 * LES FONCTIONS DE L'OFFRE ET LEUR NIVEAU, POUR LE TABLEAU « DEUX NIVEAUX ».
 * ============================================================================
 *
 * Reprises de la maquette (`OFFRE`, lignes qui portent `client`, S:5726-5743),
 * dans l'ordre de `ordreOffre` (le Basique d'abord). Le niveau de chaque ligne
 * est celui que la maquette lit dans la matrice des accès (`niveauFonction`) :
 * le niveau commun de ses gestes. `niveaux.spec.ts` le confronte à la copie
 * de `matrice.json`. Le texte de chaque ligne est sous
 * `alarmesV2.option.niveaux.lignes.<cle>`.
 */

/** Une fonction : la clé de son texte, ses gestes, et vrai si le Basique la comprend. */
export interface NiveauDeFonction {
    cle: string
    gestes: readonly string[]
    basique: boolean
}

export const NIVEAUX_DES_FONCTIONS: readonly NiveauDeFonction[] = [
    {
        cle: "creer",
        gestes: ["declarer_par_une_phrase", "declarer_une_surveillance"],
        basique: true,
    },
    {
        cle: "fiche",
        gestes: [
            "fiche_mettre_hors_service",
            "fiche_remettre_en_service",
            "fiche_modifier_parametres",
        ],
        basique: true,
    },
    {
        cle: "messages",
        gestes: [
            "etre_destinataire",
            "lien_lire_page",
            "lien_prendre_en_compte",
            "acquitter_depuis_l_ecran",
        ],
        basique: true,
    },
    {
        cle: "horaires",
        gestes: ["horaires_voir", "horaires_declarer_modifier"],
        basique: true,
    },
    {
        cle: "ecart",
        gestes: [
            "declarer_ecart_inhabituel",
            "episode_avis_utilite",
            "lien_avis_utilite",
        ],
        basique: true,
    },
    {
        cle: "plusieurs",
        gestes: [
            "declarer_plusieurs_objets",
            "liste_mettre_hors_service_selection",
            "liste_remettre_en_service_selection",
            "liste_changer_destinataires_selection",
        ],
        basique: false,
    },
    {
        cle: "fermerSites",
        gestes: ["horaires_fermer_plusieurs_sites"],
        basique: false,
    },
    { cle: "rappels", gestes: ["relances_astreinte"], basique: false },
    {
        cle: "sms",
        gestes: [
            "declarer_canal_sms",
            "sms_voir_solde",
            "sms_voir_mouvements",
            "sms_recharger",
            "sms_alertes_solde",
        ],
        basique: false,
    },
    {
        cle: "test",
        gestes: ["test_pour_soi", "test_pour_autrui", "test_lire_resultat"],
        basique: false,
    },
    {
        cle: "recapitulatif",
        gestes: [
            "recapitulatif_et_synthese",
            "declarer_rythme_autrui",
            "rythme_pour_soi",
        ],
        basique: false,
    },
]
